import { Button } from 'antd'
import { FC, useCallback, useMemo, useState } from 'react'

import { getJustificationVariantProps } from './justificationButtonVariant'
import {
  JustificationDialog,
  type JustificationDialogProps,
} from './JustificationDialog'

export interface JustificationButtonProps extends Omit<
  JustificationDialogProps,
  'open' | 'title' | 'text' | 'onTextChange' | 'onClose'
> {
  label: string
  dialogTitle?: string
  disabled?: boolean
  loading?: boolean
  size?: 'small' | 'middle' | 'large'
}

export const JustificationButton: FC<JustificationButtonProps> = ({
  label,
  dialogTitle,
  variant = 'neutral',
  disabled = false,
  loading = false,
  size = 'middle',
  ...dialogProps
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [text, setText] = useState('')

  const openDialog = useCallback(() => {
    setText('')
    setIsOpen(true)
  }, [])
  const closeDialog = useCallback(() => setIsOpen(false), [])

  const variantProps = useMemo(
    () => getJustificationVariantProps(variant),
    [variant]
  )

  return (
    <>
      <Button
        {...variantProps}
        size={size}
        disabled={disabled}
        loading={loading}
        onClick={openDialog}>
        {label}
      </Button>
      <JustificationDialog
        {...dialogProps}
        open={isOpen}
        title={dialogTitle ?? label}
        variant={variant}
        text={text}
        onTextChange={setText}
        onClose={closeDialog}
      />
    </>
  )
}
